import { combineReducers } from 'redux';
import InputReducer from './InputReducer';
import authReducer from './authReducer';
import subscriptionReducer from './subscriptionReducer';
import adminReducer from './adminReducer';

export default combineReducers({
  InputReducer,
  auth: authReducer,
  subscription: subscriptionReducer,
  admin: adminReducer,
});
